export default __webpack_public_path__ + "static/media/WaterGoodQualityArea.a13b2148.png";